import { render } from "./lhc-bet-odds-detail-confirm.vue?vue&type=template&id=03d3d557&scoped=true"
import script from "./lhc-bet-odds-detail-confirm.vue?vue&type=script&lang=js"
export * from "./lhc-bet-odds-detail-confirm.vue?vue&type=script&lang=js"

import "./lhc-bet-odds-detail-confirm.vue?vue&type=style&index=0&id=03d3d557&scoped=true&lang=less"

import exportComponent from "F:\\workspan\\java\\lot\\hk-lottery-lhc-pc-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03d3d557"]])

export default __exports__